export enum Edition {
  Asia = "asia",
  HongKong = "hk",
  International = "int",
  UnitedStates = "us",
}

export const editions = {
  [Edition.International]: { href: "/", label: "International" },
  [Edition.HongKong]: { href: "/hk", label: "Hong Kong" },
  [Edition.UnitedStates]: { href: "/us", label: "United States" },
  [Edition.Asia]: { href: "/asia", label: "Asia" },
} as const;

export const editionOptions = [
  Edition.International,
  Edition.HongKong,
  Edition.UnitedStates,
  Edition.Asia,
].map(edition => ({ value: edition, ...editions[edition] }));
